// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".grab{cursor:grab}.grab:active{cursor:grabbing}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/order_allocation/OrderAllocationToTeamMemberPage.vue"],"names":[],"mappings":"AACA,MACC,WAAA,CACA,aACC,eAAA","file":"OrderAllocationToTeamMemberPage.vue","sourcesContent":["\n.grab {\n\tcursor: grab;\n\t&:active {\n\t\tcursor: grabbing;\n\t}\n}\n"]}]);
// Exports
module.exports = exports;
